<template>
    <table class="update_variation_form edit_cart_items">
        <tbody>
        <tr>
            <td class="pro_img">
                <a href="javascript:" v-on:click="$emit('onCancel')" class="close_opdate_variations_btn">×</a>
                <div class="product-name-mobile">
                    <a :href="cartItem.publish_url">{{cartItem.title}}</a>
                </div>
                <div class="product_gallery_image">
                    <wrap-image width="500" height="500" class="product-post-image" :prop-image="image"/>
                </div>
            </td>
            <td class="variations edit-variation">
                <form class="variations_form cart" action="javascript:" method="post" enctype="multipart/form-data">

                    <table class="variations">
                        <tbody>
                        <tr v-for="attr in this.showAttributes">
                            <td class="label">
                                <label :for="`attribute_${attr.slug}`">{{ attr.name }}</label>
                            </td>
                            <td class="value">
                                <select class="variation" :class="{'no-select': attr.options.length === 1}" :name="attr.slug" :id="`attribute_${attr.slug}`" :data-id="attr.id" v-on:change="changeVariationOption">
                                    <option value="">Choose an Option</option>
                                    <option v-for="option in attr.options" :class="attr.options.length === 1 || (options[attr.slug] && options[attr.slug] === option.slug) ? 'selected' : '' " :selected="attr.options.length === 1 || (options[attr.slug] && options[attr.slug] === option.slug)" :value="option.slug" :data-id="option.id">{{ option.name }}</option>
                                </select>
                            </td>
                        </tr>
                        <tr v-for="(extraAttr, index) in extraAttribute" v-if="extraAttribute.length">
                            <td class="label">
                                <label :for="`attribute_${index}`">{{ extraAttr.name + ' ' + (index + 1)}}</label>
                            </td>
                            <td class="value">
                                <select :class="`extra_attribute `" v-model="extraAttrOptions[index]" :name="`extra_attribute_${index}`" v-on:change="changeExtraAttrOptions" :id="`extra_attribute_${index}`">
                                    <option :value="undefined">Choose an Option</option>
                                    <option v-for="extraOption in extraAttr.extra_attribute_options" :value="extraOption" :class="Object.keys(extraAttrOptions).length >= 1 && extraAttrOptions.hasOwnProperty(index) && typeof extraAttrOptions[index] !== 'undefined' && extraAttrOptions[index].id === extraOption.id ? 'selected '+extraAttrOptions[index] : ''">
                                        {{ extraOption.name }}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="mobile-hide clear-option-checkout">&nbsp;</td>
                            <td class="text-right"><a :class="`reset_variations `+Object.keys(options).length+` `+attributes.length+` `+product.variations.length" v-if="options && Object.keys(options).length == attributes.length && product.variations.length > 1" v-on:click="changeVariationOption()">Clear Options</a></td>
                        </tr>
                        <tr class="unavalable-message">
                            <td colspan="1"><a style="text-decoration: unset;" class="unavalable text-sorry-message font-weight-light" v-if="!selectedVariation && options && Object.keys(options).length == attributes.length && this.showMessage">Sorry, the combination of options you have selected is unavailable. Please choose a different combination.</a></td>
                        </tr>
                        <tr v-if="isOutOfStock">
                            <td colspan="5" class="unavalable-message out-of-stock-edit"><a style="text-decoration: unset;" class="unavalable font-weight-light" >Out Of Stock</a></td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="single_variation">
                        <div class="variation_price" v-if="selectedVariation">
                            <span class="price_txt">PRICE</span>
                            <span class="price">{{ priceFormatter(cartItem.price) }} {{cartItem.price_label ? cartItem.price_label : "ea."}}</span>
                        </div>
                        <div class="variations_quantity_control">
                            <div class="quantity">
                                <input type="number" class="show-sqft" v-model="quantity" min="1" @focusout="onQuantityInput($event, cartItem)" v-on:change="updateQuantity($event, cartItem)">
                                <span class="product-price-per-sqft">{{cartItem.units ? cartItem.units : "each"}}</span>
                            </div>

                            <div class="quantity_mobile">
                                <label class="label">QUANTITY <br> {{cartItem.units ? cartItem.units : "each"}}</label>
                                <div>
                                    <div>
                                        <a href="javascript:;" class="decrement" v-on:click="decrementQty">-</a>
                                        <input type="number" class="show-sqft" v-model="quantity" min="1" @focusout="onQuantityInput($event, cartItem)" v-on:change="updateQuantity($event, cartItem)">
                                        <a href="javascript:;" class="increment"  v-on:click="incrementQty">+</a>
                                    </div>
                                </div>
                            </div>

                            <!--                                            <div class="sub_total_price">-->
                            <!--                                                <span class="sub_total_txt">SUBTOTAL</span>-->
                            <!--                                                <span class="sub_total">$10,710.00</span>-->
                            <!--                                            </div>-->

                            <div class="action_buttons">
                                <button type="submit" :disabled="isDisabled" v-on:click="updateProduct" class="update_variations_btn">Update</button>
                                <br>
                                <a href="javascript:" v-on:click="$emit('onCancel')" class="cancel_opdate_variations_btn">Cancel</a>
                            </div>
                        </div>
                    </div>
                </form>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import Flickity from 'vue-flickity'
import 'flickity-as-nav-for'

import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import ProductTabs from "./ProductTabs";
import {mapActions} from "vuex";
import WrapImage from "../WrapImage";

export default {
    name: 'product-edit-section',
    props: ['propCartItem','propCartIndex'],
    components: {
        WrapImage,
        ProductTabs,
        Flickity,
        CoolLightBox
    },
    data() {
        return {
            showMessage: true,
            selectedVariation: null,
            showAttributes: {},
            clear_options: 0,
            quantity: this.propCartItem.quantity,
            cartItem: this.propCartItem,
            options: this.propCartItem.options,
            options_ids: this.propCartItem.options_ids,
            image: null,
            extraAttrCount: Object.keys(this.propCartItem.extra_attribute_options).length,
            extraAttrOptions: this.propCartItem.extra_attribute_options,
            extraAttrs: JSON.parse(JSON.stringify(this.propCartItem.extra_attribute)),
            filters:
            {
                product_id: "",
                attr_ids: "",
            }
        }
    },
    mounted() {
        this.checkCartItems();

        this.$nextTick(function () {
            const navBtns = document.querySelectorAll('body .carousel-main .flickity-button-icon')
            const navBtnNext = document.querySelectorAll('body .init-flickity .flickity-prev-next-button.next svg path')
            if(navBtns) {
                navBtns.forEach(el => {
                    el.setAttribute('viewBox', '0 0 512 512')
                })
            }
            if(navBtnNext) {
                navBtnNext.forEach(el => {
                    el.setAttribute('transform', 'translate(0, 0) rotate(180)')
                    el.setAttribute('transform-origin', 'center')
                })
            }
        })

        this.$nextTick(() => {
            if(this.cartItem.options) {
                this.getVariation()
                this.showRedToSelect();
            }
        })

        for(let i = 0; i < this.attributes.length; i++) {

            if(this.attributes[i].slug == 'beam-texture-type')
            {
                this.getBeamSizeVarations(this.options['beam-texture-type'],this.options['beam-size']);
            }
        }

        this.showRedToSelect();

        const beamTextureType = this.showAttributes.find(item => item.slug == 'beam-texture-type');

        if(!beamTextureType){
            this.getDynamicVariation();
        }

    },
    created(){
        this.dataLayerViewItem(this.cartItem);
    },
    computed: {
        product() {
            return this.mapProductItem(this.$store.state.app.products.find(i => i.id === this.cartItem.id))
        },
        sku() {
            return this.selectedVariation ? this.selectedVariation.sku : this.product.sku
        },
        qtyStep() {
            if(this.isFunctionalityForAdminEnabled || this.product.allow_combination) {
                return this.product.group_of || 1
            }
            else if(!this.product.enable_functionality_for_admin && this.isadmin)
            {
                return this.product.group_of || 1
            }
            else
            {
                return this.product.group_of || 1
            }
        },
        attributes() {
            const attributes = [];
            let variations = this.product.variations;

            // if (this.product.id === 314) {
            //     variations = []
            //     for(let j = 0; j < this.product.variations.length; j++) {
            //         const variant = this.product.variations[j];
            //         let skipVariant = false;
            //         for(let attr in this.options) {
            //             if(variant.attribute_options?.find(item => item?.attribute?.slug === attr) && this.currentlySelectedAttribute !== attr
            //                 && !variant.uid.includes(`${attr}=${this.options[attr]}`)) {
            //                 skipVariant = true;
            //             }

            //         }

            //         if(skipVariant) {
            //             continue;
            //         }

            //         variations.push(this.product.variations[j]);
            //     }
            // }
            let activeAttributeOptions = {}
            variations.map((i) => {
                i.uid.split('_').map((j) => {
                    const [attr, opt] = j.split('=');
                    if(! activeAttributeOptions[attr]) {
                        activeAttributeOptions[attr] = []
                    }

                    activeAttributeOptions[attr].push(opt)
                })
            })
            for(let i = 0; i < this.product.attributes.length; i++) {
                const attribute = this.product.attributes[i];
                const options = attribute.options.filter(opt => !activeAttributeOptions[attribute.slug] || activeAttributeOptions[attribute.slug].includes(opt.slug))
                if(options.length) {
                    attributes.push({...attribute, ...{options}});
                }
            }

            this.showAttributes = attributes;

            return attributes
        },
        extraAttribute() {

            if (!this.cartItem.extra_attribute) {
                return []
            }

            const extraAttr = []
            for (let i= 0; i < this.extraAttrCount; i++ ) {
                extraAttr[i] = this.product.extra_attribute
            }
            
            return extraAttr
        },
        isValidExtraOptionCnt() {

            this.extraAttrs.options = this.filterUndefinedKeys(this.extraAttrOptions);
            const dataArray = Object.entries(this.extraAttrOptions);
            const top2Objects = dataArray.slice(0, this.extraAttrCount);
            this.extraAttrOptions = Object.fromEntries(top2Objects);

            return (!this.extraAttrCount || (this.extraAttrCount && Object.entries(this.extraAttrOptions).length >= this.extraAttrCount));
        },
        invalidExtraAttrCnt() {
            return !!(this.extraAttrCount && Object.keys(this.cartItem.extra_attribute.options).filter(i=>this.cartItem.extra_attribute.options[i]).length !== +this.extraAttrCount)
        },
        isFunctionalityForAdminEnabled() {
            return this.product.enable_functionality_for_admin && this.$store.getters.isAdmin
        },
        isOutOfStock() {
            return this.itemForCart && this.itemForCart.stock_status !== 'in_stock'
        },
        isDisabled() {

            return !this.itemForCart || this.isOutOfStock || !this.isValidExtraOptionCnt
        },
        itemForCart() {
            return this.mapCartItem({product: this.propCartItem, variation: this.selectedVariation, options: this.options, sku: this.sku, extraAttribute: this.cartItem.extra_attribute, optionsIds: this.options_ids})
        }
    },
    methods: {
        ...mapActions(["updateCartItem", "saveCart", "calcGroundFreight",'checkCartItems',"beforeCalcGroundFreight", 'cartMinQtyNote']),
        dataLayerViewItem(selectedVariation)
        {
            window.dataLayer = window.dataLayer || [];

            if(this.$store.state.cart.items.length)
            {
                let products = [];
                let items = [];

                this.$store.state.data_layer_change_detail_view_eec.ecomm_prodid = selectedVariation ? selectedVariation.sku : "";
                this.$store.state.data_layer_change_detail_view_eec.ecomm_totalvalue = selectedVariation ? selectedVariation.price : "";
                this.$store.state.data_layer_view_item.ecommerce.value = selectedVariation ? selectedVariation.price : "";

                let options =  Object.values(this.options);
                let category =  this.cartItem.categories.length > 0 ? this.cartItem.categories[0].meta_title : "";

                products[0] = {};
                products[0].brand = "";
                products[0].category = category;
                products[0].id = selectedVariation ? selectedVariation.sku : "";
                products[0].name = selectedVariation ? selectedVariation.title : "";
                products[0].price = selectedVariation ? parseFloat(selectedVariation.price) : "";
                products[0].stocklevel = "";
                products[0].variant = options ? options.join(",") : "";

                items[0] = {};
                items[0].google_business_vertical = "retail";
                items[0].id = selectedVariation ? selectedVariation.sku : "";
                items[0].item_brand = "";
                items[0].item_category = category;
                items[0].item_id = selectedVariation ? selectedVariation.sku : "";
                items[0].item_name = selectedVariation ? selectedVariation.title : "";
                items[0].item_variant = options ? options.join(",") : "";
                items[0].price = selectedVariation ? parseFloat(selectedVariation.price) : "";

                this.$store.state.data_layer_change_detail_view_eec.ecommerce.detail.products = products;
                this.$store.state.data_layer_view_item.ecommerce.items = items;

                // for(let i=0; i<obj1Keys.length; i++) {
                //     window.dataLayer[i] = window.dataLayer[obj1Keys[i]];
                // }

                // for(let i=0; i<obj2Keys.length; i++) {
                //     window.dataLayer[i+obj1Keys.length] = this.$store.getters.changeDetailsDataLayer[obj2Keys[i]];
                // }

                window.dataLayer.push(this.$store.getters.changeDetailsDataLayer[0]);
                window.dataLayer.push(this.$store.getters.changeDetailsDataLayer[1]);
            }
            else
            {
                this.$store.state.data_layer_change_detail_view_eec.ecomm_prodid = "";
                this.$store.state.data_layer_change_detail_view_eec.ecomm_totalvalue = "0.00";
                this.$store.state.data_layer_view_item.ecommerce.value = "0.00";
            }
        },
        filterUndefinedKeys(obj) {
            const filteredObj = {};
            Object.keys(obj).forEach(key => {
                if (obj[key] !== undefined) {
                    filteredObj[key] = obj[key];
                }
            });
            return filteredObj;
        },
        isValidExtraOptionCntMethod() {

            this.extraAttrs.options = this.filterUndefinedKeys(this.extraAttrs.options);
            const dataArray = Object.entries(this.extraAttrs.options);
            const top2Objects = dataArray.slice(0, this.extraAttrCount);
            this.extraAttrs.options = Object.fromEntries(top2Objects);

            return (!this.extraAttrCount || (this.extraAttrCount && Object.entries(this.extraAttrs.options).length >= this.extraAttrCount));
        },
        dataLayerUpdateItem(selectedVariation)
        {
            window.dataLayer = window.dataLayer || [];

            if(this.$store.state.cart.items.length)
            {
                let products = [];
                let items = [];

                this.$store.state.data_layer_add_to_cart.ecommerce.value = this.quantity*selectedVariation.price;

                let options =  Object.values(this.options);

                let category = "";

                if(typeof(this.cartItem.categories) != "undefined" && this.cartItem.categories !== null)
                    category =  this.cartItem && this.cartItem.categories.length > 0 ? this.cartItem.categories[0].meta_title : "";

                products[0] = {};
                products[0].brand = "";
                products[0].category = category;
                products[0].id = selectedVariation ? selectedVariation.sku : "";
                products[0].name = selectedVariation ? selectedVariation.title : "";
                products[0].price = selectedVariation ? parseFloat(selectedVariation.price) : "";
                products[0].quantity = this.quantity;
                products[0].stocklevel = "";
                products[0].variant = options ? options.join(",") : "";

                items[0] = {};
                items[0].google_business_vertical = "retail";
                items[0].id = selectedVariation ? selectedVariation.sku : "";
                items[0].item_brand = "";
                items[0].item_category = category;
                items[0].item_id = selectedVariation ? selectedVariation.sku : "";
                items[0].item_name = selectedVariation ? selectedVariation.title : "";
                items[0].item_variant = options ? options.join(",") : "";
                items[0].price = selectedVariation ? parseFloat(selectedVariation.price) : "";
                items[0].quantity = this.quantity;

                this.$store.state.data_layer_add_product_to_cart_eec.ecommerce.add.products = products;
                this.$store.state.data_layer_add_to_cart.ecommerce.items = items;

                // for(let i=0; i<obj1Keys.length; i++) {
                //     window.dataLayer[i] = window.dataLayer[obj1Keys[i]];
                // }

                // for(let i=0; i<obj2Keys.length; i++) {
                //     window.dataLayer[i+obj1Keys.length] = this.$store.getters.updateDetailsDataLayer[obj2Keys[i]];
                // }

                window.dataLayer.push(this.$store.getters.updateDetailsDataLayer[0]);
                window.dataLayer.push(this.$store.getters.updateDetailsDataLayer[1]);
            }
            else
            {
                this.$store.state.data_layer_change_detail_view_eec.ecomm_prodid = "";
                this.$store.state.data_layer_change_detail_view_eec.ecomm_totalvalue = "0.00";
                this.$store.state.data_layer_view_item.ecommerce.value = "0.00";
            }
        },
        incrementQty() {
            let value = parseInt(this.quantity) + 1
            if(!value) {value = this.qtyInitialValue()}
            this.quantity = this.getUpdatedQuantity(value,this.cartItem)

        },
        decrementQty() {
            let value = parseInt(this.quantity) - 1
            if(!value) {value = this.qtyInitialValue()}
            this.quantity = this.getUpdatedQuantity(value,this.cartItem)
        },
        qtyInitialValue() {

            if(this.product.allow_combination && this.product.group_of)
            {
                return this.product.min_quantity > this.product.group_of ? this.product.group_of : "1";
            }

            if(this.product.allow_combination)
            {
                return 1;
            }
            if(this.isFunctionalityForAdminEnabledMethod(this.cartItem)) {
                return this.product.min_quantity ? this.product.min_quantity : 1;
            }
            else if(!this.product.enable_functionality_for_admin && this.isadmin)
            {
                return this.product.min_quantity && this.product.group_of ? this.product.min_quantity : 1;
            }
            else
            {
                return this.product.min_quantity ? this.product.min_quantity : 1;
            }
        },
        async changeVariationOption($event) {

            let eventName = "";
            let eventValue = "";
            if($event) {
                eventName = $event.target.name;
                eventValue = $event.target.value;

                var select = $('#attribute_'+eventName);
                var attrId = select.attr('data-id');
                var option = select.find("option[value='"+eventValue+"']");

                var optionId = option.attr('data-id');

                this.options = Object.assign({}, this.options, {[$event.target.name]: $event.target.value})

                this.options_ids = Object.assign({}, this.options_ids, {[attrId]: optionId})
                this.clear_options = 0;
            } else {
                eventName = "";
                eventValue = "";
                this.options = {}
                this.clear_options = 1;
                this.options_ids = {}
                this.extraAttrCount = 0
                this.extraAttrOptions = {}
            }
            this.selectSingleAttrOptions()

            const attrs = Object.keys(this.options)
            // this.cartItem.extra_attribute.options = {}
            for(let i = 0; i < attrs.length; i++) {
                if(attrs[i] === 'sample-kit-size') {
                    const numberIndex = this.options[attrs[i]].split('-');

                    this.extraAttrCount = Number(numberIndex[0])
                    break
                }
            }

            this.getVariation(1)

            this.showRedToSelect();

            if($event && (eventName == 'beam-texture-type' || eventName == 'beam-size'))
            {
                this.showMessage = false;
                if(eventName == 'beam-texture-type')
                    await this.getBeamSizeVarations(eventValue)
            }
            else
            {
                this.showMessage = true;
                await this.getDynamicVariation(1);
            }

            this.dataLayerViewItem(this.selectedVariation);

        },
        async getDynamicVariation(changeVariationOptionDynamic = 0)
        {
            const selectedOptionsIds = this.options_ids;
            let checkSelectedOptionsIds = Object.entries(selectedOptionsIds).filter(([key, value]) => key !== undefined && value !== undefined);

            if(checkSelectedOptionsIds.length > 0)
            {
                let concatedOptionsIds = Object.values(selectedOptionsIds).join(',');

                this.filters.product_id = this.cartItem.id;
                this.filters.attr_ids = concatedOptionsIds;
                const url = new URL(window.location.origin + '/products/get-variations/')
                const params = url.searchParams

                Object.keys(this.filters).map(key => {
                    if(this.filters[key]) {
                        params.set(key, this.filters[key])
                    } else {
                        params.delete(key)
                    }
                })

                url.search = params.toString()
                const newUrl = url.toString()

                const {data} = await axios.get(newUrl)

               if(data.status){

                    const attributes = [];
                    let variations = this.product.variations;
                    let activeAttributeOptions = {}
                    variations.map((i) => {
                        i.uid.split('_').map((j) => {
                            const [attr, opt] = j.split('=');
                            if(! activeAttributeOptions[attr]) {
                                activeAttributeOptions[attr] = []
                            }
                            activeAttributeOptions[attr].push(opt)
                        })
                    })
                    for(let i = 0; i < data.data.length; i++) {
                        const attribute = data.data[i];
                        const options = attribute.options.filter(opt => !activeAttributeOptions[attribute.slug] || activeAttributeOptions[attribute.slug].includes(opt.slug))
                        if(options.length) {
                            attributes.push({...attribute, ...{options}});
                        }
                    }

                    this.showAttributes = attributes;
                }
            }
        },
        onQuantityInput($event, item) {
            let quantity = Number(Math.ceil($event.target.value)) <= 0 ? 1 : Number(Math.ceil($event.target.value))

            // if(quantity && quantity > 9999) {
            //     quantity = 9999;
            // }

            if(this.isFunctionalityForAdminEnabledMethod(item) || !this.$store.getters.auth){
                if(item.min_quantity && item.min_quantity > quantity) {
                    if(!item.allow_combination) {
                        quantity = item.min_quantity
                    }
                }

                quantity = this.getQtyGrouped(quantity, item)

                if(item.max_quantity && item.max_quantity < quantity) {
                    quantity = item.max_quantity
                }
            }

            $event.target.value = quantity
            this.quantity = quantity
        },
        getQtyGrouped(qty, item) {
            if(item.group_of && item.group_of > 1 && (qty / item.group_of) % 1 !== 0) {

               if (qty > item.editQuantity) {
                   qty = qty - qty % item.group_of + item.group_of
               } else if (qty < item.editQuantity) {
                   qty = item.editQuantity - item.editQuantity % item.group_of - item.group_of
               }
                return qty
            }
            return qty
        },
        getUpdatedQuantity(value, item) {
            let letQuantity = Number(value) <= 0 ? 1 : Number(value)


            if(item.editQuantity == undefined){
                item.editQuantity = 0;
            }

            if(this.isFunctionalityForAdminEnabledMethod(item) || !this.$store.getters.auth) {

                if(item.min_quantity && item.min_quantity > letQuantity) {
                    if(!item.allow_combination) {
                        letQuantity = item.min_quantity
                    }
                }

                if(item.editQuantity == 0){
                    item.editQuantity = item.quantity
                }
                letQuantity = this.getQtyGrouped(letQuantity, item)

                if(item.max_quantity && item.max_quantity < letQuantity) {
                    letQuantity = item.max_quantity
                }
            }

            if(!letQuantity) {
                letQuantity = 1;
            }

            this.quantity = letQuantity;
            item.editQuantity = letQuantity;

            return letQuantity;
        },
        updateQuantity($event, item) {
            let letQuantity = Number(Math.ceil($event.target.value)) <= 0 ? 1 : Number(Math.ceil($event.target.value))

            if(item.editQuantity == undefined){
                item.editQuantity = 0;
            }

            if(this.isFunctionalityForAdminEnabledMethod(item) || !this.$store.getters.auth) {

                if(item.min_quantity && item.min_quantity > letQuantity) {
                    if(!item.allow_combination) {
                        letQuantity = item.min_quantity
                    }
                }

                if(item.editQuantity == 0){
                    item.editQuantity = item.quantity
                }
                letQuantity = this.getQtyGrouped(letQuantity, item)

                if(item.max_quantity && item.max_quantity < letQuantity) {
                    letQuantity = item.max_quantity
                }
            }

            if(!letQuantity) {
                letQuantity = 1;
            }

            // if(quantity && quantity > 9999) {
            //     quantity = 9999;
            // }
            this.quantity = letQuantity;
            item.editQuantity = letQuantity;

            // this.updateCartQuantity(Object.assign(item, {quantity})).then(res => {
            //     if(!this.isShippingUpdate) {
            //         this.isShippingUpdate = true
            //         setTimeout( () => {
            //             this.calculateShipping().then(res => {
            //                 this.isShippingUpdate = false
            //                 this.saveCart({page: 'cart'})
            //                 this.cartMinQtyNote()
            //             })
            //         }, 2000)
            //     }
            //     // this.saveCart({page: 'cart'})
            // })
        },
        getBeamSizeVarations(value,selectedOption = "")
        {
            let productId = this.product.id;
            axios.get(`/product/get-beam-size-attributes/${value || ''}`+`/${productId || ''}`+`/${selectedOption || ''}`).then(({data}) => {

                if(data.status == "success")
                {
                    let filteredItems = this.showAttributes.filter(function (item) {
                        return item.slug === 'beam-size'
                    });

                    filteredItems[0].options = data.attrOptions;

                    this.showRedToSelect();
                }
                else
                {
                    // if($('select[id="attribute_beam-size"]').length)
                    //     $('select[id="attribute_beam-size"]').html("");
                }

            }).catch(errors => {
            });
        },
        getVariation(changeVariation = 0) {

            for(let i = 0; i < this.product.variations.length; i++) {
                const selectedOptions = {}

                for(let j = 0; j < this.product.variations[i].attribute_options.length; j++) {
                    const attribute = this.product.variations[i].attribute_options[j].attribute.slug
                    if(attribute && this.options[attribute]) {
                        selectedOptions[attribute] = this.options[attribute]
                    }
                }
                const selectedOptionValues = this.generateItemUid({attributes: selectedOptions})
                if(selectedOptionValues === this.product.variations[i].uid) {
                    this.selectedVariation = this.product.variations[i]
                    if(changeVariation)
                    {
                        this.options = this.options
                        this.option_old = selectedOptions

                    }
                    else
                    {
                        this.options = selectedOptions
                        this.option_old = selectedOptions
                    }
                    break;
                } else {
                    this.selectedVariation = null
                }
            }
            if(!this.clear_options && !changeVariation){
                this.options = Object.assign({}, this.cartItem.options,this.options );
            }

            if(this.selectedVariation) {

                const [imageIndex, image] = this.getSelectedImage()
                if(image) {
                    this.image = image
                }

                this.selectedVariation.image = image
            }
        },
        getSelectedImage() {
            const attributeHash = this.generateItemUid({attributes: this.option_old})

            let imageIndex = this.product.variations.findIndex(i => i.uid === attributeHash)

            imageIndex = (imageIndex !== -1) ? imageIndex : 0

            const image = imageIndex >= 0 && this.product.variations[imageIndex].main_image ? this.product.variations[imageIndex].main_image : this.product.main_image

            return [imageIndex, image]
        },
        updateProduct() {

            this.extraAttrs.options = this.filterUndefinedKeys(this.extraAttrs.options);
            const dataArray = Object.entries(this.extraAttrs.options);
            const top2Objects = dataArray.slice(0, this.extraAttrCount);
            this.cartItem.extra_attribute.options = Object.fromEntries(top2Objects);

            if(!this.selectedVariation || !this.itemForCart || !this.isValidExtraOptionCntMethod()) {
                return null
            }

            if(this.itemForCart && this.itemForCart.stock_status !== 'in_stock')
                return null;

            this.updateCartItem({
                old: this.propCartItem,
                new: {...this.itemForCart, ...{quantity: Number(Math.ceil(this.quantity))}},
                cartIndex: this.propCartIndex
            }).then(res => {
                this.saveCart({page: 'cart'})
                if(!this.$store.state.app.auth)
                {
                    this.$store.state.cart.cart_type = this.$store.state.cart.cart_type == '1' ? '0' : this.$store.state.cart.cart_type;
                    this.$store.state.shipping_methods.custom_price = null
                }
                this.beforeCalcGroundFreight()
                this.dataLayerUpdateItem(this.selectedVariation)
                this.cartMinQtyNote()
            })
            this.$emit('onSuccess')
        },
        selectSingleAttrOptions() {
            for(let i = 0; i < this.attributes.length; i++) {
                if(this.attributes[i].options.length === 1) {
                    this.options[this.attributes[i].slug] = this.attributes[i].options[0].slug

                    var select = $('#attribute_'+this.attributes[i].slug);
                    var attrId = select.attr('data-id');
                    var option = select.find("option[value='"+this.attributes[i].options[0].slug+"']");

                    var optionId = option.attr('data-id');
                    this.options_ids[attrId] = optionId
                }
            }
        },
        setCustomPrice($event, item){
            let customPrice = $event.target.value
            this.updateCustomPrice(Object.assign(item, {customPrice})).then(res => {
                this.saveCart({page: 'cart'})
            })
        },
        showRedToSelect()
        {
            setTimeout(function()
            {
                $('.variation').each(function(){
                    if($(this).find('option').hasClass('selected'))
                    {
                        $(this).removeClass('show_red');
                    }
                    else
                    {
                        $(this).addClass('show_red');
                    }
                });

                if($('.extra_attribute').length)
                {
                    $('.extra_attribute').each(function(){
                        if($(this).find('option').hasClass('selected'))
                        {
                            $(this).removeClass('show_red');
                        }
                        else
                        {
                            $(this).find('option[value=""]').prop('selected',true);
                            $(this).addClass('show_red');
                        }
                    });
                }
            },100)
        },
        changeExtraAttrOptions($event)
        {
            if($event.target.value)
                $event.target.classList.remove('show_red');
            else
                $event.target.classList.add('show_red');
        },
        isFunctionalityForAdminEnabledMethod(item) {

            return item.enable_functionality_for_admin && this.$store.getters.auth
        }
    },
}
</script>

<style scoped>
.edit-variation .variations select.variation option:first-child {
    display: none;
}
select.no-select {
    pointer-events: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    line-height: 19px;
}
</style>
